import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";
import { AdalHttp } from '../../services/adal.http.service';
@Injectable()
export class AnnotationStreamManagementV2 {
    constructor(private http: AdalHttp) {
    }

    annotationStreamsBySystemGuid(systemGuid: string, tenants:string): Observable<any> {
        let url = `api/tenants/${tenants}/annotationManagementV2/systemGuid/${systemGuid}/`;
        return this.http.get(url)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/annotationStreamManagementV2/annotation-stream-management.service.ts
 **/